import { getSecuritiesWithdrawalSchema } from './securitiesWithdrawalSchema';

export const getSecuritiesDepositSchema = getSecuritiesWithdrawalSchema;
